import React from "react";
import { BACKEND_URL } from "../../lib/api";

export const Card = ({ title, right, children, className = "", testid }) => (
  <section className={`bg-white rounded-2xl border border-[var(--line)] p-5 ${className}`} data-testid={testid}>
    {(title || right) && <div className="flex items-center gap-3 mb-3"><h3 className="font-serif text-xl flex-1">{title}</h3>{right}</div>}
    {children}
  </section>
);

export const Stat = ({ label, value, sub, testid }) => (
  <div className="bg-white rounded-2xl border border-[var(--line)] px-4 py-3" data-testid={testid}>
    <p className="text-[10px] uppercase tracking-[0.2em] text-[#5c544b]">{label}</p>
    <p className="font-serif text-3xl mt-1 tabular-nums">{value ?? "—"}</p>
    {sub && <p className="text-[11px] text-[#5c544b] mt-0.5">{sub}</p>}
  </div>
);

const SRC = { measured: ["Measured", "bg-emerald-50 text-emerald-800 border-emerald-200"], estimate: ["Third-party estimate", "bg-sky-50 text-sky-800 border-sky-200"], ai: ["AI recommendation", "bg-violet-50 text-violet-800 border-violet-200"], none: ["Not connected", "bg-black/5 text-[#5c544b] border-[var(--line)]"] };
export const Source = ({ kind, children }) => <span className={`inline-flex items-center text-[10px] uppercase tracking-wider px-2 py-0.5 rounded-full border ${SRC[kind][1]}`}>{children || SRC[kind][0]}</span>;

export const STATUS_CLS = { planned: "bg-black/5", drafted: "bg-amber-50 text-amber-800", in_review: "bg-sky-50 text-sky-800", approved: "bg-violet-50 text-violet-800", published: "bg-emerald-50 text-emerald-800", held: "bg-red-50 text-red-800" };
export const Pill = ({ s }) => <span className={`text-[10px] uppercase tracking-wider px-2 py-0.5 rounded-full ${STATUS_CLS[s] || "bg-black/5"}`}>{(s || "").replace("_", " ")}</span>;

export const SEV = { high: "text-red-700", medium: "text-amber-700", low: "text-[#5c544b]" };

export const scoreColor = (s) => (s >= 80 ? "text-emerald-700" : s >= 60 ? "text-amber-700" : "text-red-700");

export const download = (path) => window.open(`${BACKEND_URL}/api${path}`, "_blank", "noopener");

export const Ring = ({ score, size = 120 }) => {
  const r = size / 2 - 8, c = 2 * Math.PI * r, pct = Math.max(0, Math.min(100, score || 0));
  return (
    <svg width={size} height={size} className="shrink-0" data-testid="seo-score-ring">
      <circle cx={size / 2} cy={size / 2} r={r} stroke="#ece6dc" strokeWidth="8" fill="none" />
      <circle cx={size / 2} cy={size / 2} r={r} stroke="var(--gold)" strokeWidth="8" fill="none" strokeLinecap="round" strokeDasharray={c} strokeDashoffset={c * (1 - pct / 100)} transform={`rotate(-90 ${size / 2} ${size / 2})`} style={{ transition: "stroke-dashoffset 900ms ease" }} />
      <text x="50%" y="50%" dominantBaseline="central" textAnchor="middle" className="font-serif" fontSize={size / 3.4}>{score ?? "—"}</text>
    </svg>
  );
};
